import { RequireAtLeastOne } from "@/types/util/RequireAtLeastOne"
import { ScopedFeatureType, useScopedFeatures } from "@utils/hook/useScopedFeatures"

type ScopedFeatureProps = {
  feature: ScopedFeatureType
} & RequireAtLeastOne<{
  enabled?: React.ReactNode
  disabled?: React.ReactNode
}>

function ScopedFeature(props: ScopedFeatureProps) {
  const isScopedFeatureEnabled = useScopedFeatures()

  if (isScopedFeatureEnabled(props.feature)) return <>{props.enabled}</>
  return <>{props.disabled}</>
}

export default ScopedFeature
